import * as Sentry from '@sentry/gatsby';

const activeEnv =
  process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';

Sentry.init({
  dsn: 'https://3696b8861ce249cc92c562644531542d@o430573.ingest.sentry.io/6144635',
  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category === 'console') {
      return null;
    }
    return breadcrumb;
  },
  sendDefaultPii: true,
  _experiments: {
    enableLogs: true,
    beforeSendLog: (log) => {
      if (log.level === 'console') {
        return null;
      }
      return log;
    },
  },
  environment: activeEnv,
  sampleRate: 0.7,
  enabled: process.env.ENABLE_SENTRY !== 'false',
});
